module.exports = __webpack_public_path__ + "media/images/photo/top/reason1-8f800176deb99d9c216481d98f646306.jpg";